import React, {FC, useEffect, useState, useRef} from 'react';
import { connect, useDispatch } from 'react-redux';
import chatInfoImage from 'assets/svg/chat-info.svg';
import socialPlayFavIcon from 'assets/images/socialPlayFavIcon.png';

import Styles from 'components/chatContent/chatHeader/ChatHeader.module.scss';
import {
  deleteRoom,
  deleteRequest,
  updateParticipantsInRoom,
} from 'store/services/firebase-broadcast';
import { useHistory } from "react-router";
import deleteIcon from 'assets/svg/delete icon.svg';
import userRequestIcon from 'assets/images/user-request.png';
import CustomModal from 'components/customModal/CustomModal';
import { IMAGE_URL } from 'store/services/URL';
import { getCurrentDate, randomString, setTime } from 'helpers/utils';
import { onValue, ref } from "firebase/database";
import { db } from 'utils/firebase-config';
import Button from 'components/button/Button';
import Toast from 'components/toast/Tost';
import { invitePeopleRequest } from 'store/actions/general.actions';
import { roomDeleteRequest, roomStatusRequest } from 'store/actions/conversation.actions';
import api from 'store/services/conversation.service';
import { generateMeetingLink, decodeMeetingLink } from 'utils/meetingLinkUtils';

interface ChatHeaderProps {
  cssClass?: string;
  name: string;
  chatInfo?: Function;
  selected: any;
  isJoined: boolean;
  invitePeople: Function;
}

const ChatHeader: FC<ChatHeaderProps> = (props: ChatHeaderProps) => {
  const { cssClass, name, chatInfo, selected, isJoined, invitePeople } = props;
  const [toast, setToast] = useState(false);
  const [toastValues, setToastValues] = useState({message: '', type: ''});
  const [joinRequest, setJoinRequest] = useState(false);
  const [requests, setRequests] = useState([]);
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  const [shouldCheckModalClose, setShouldCheckModalClose] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const dispatch = useDispatch();
  const closeDialog = () => {
    document.body.classList.remove('modal-open');
    setJoinRequest(false);
  };

  const closeDeleteConfirm = () => {
    document.body.classList.remove('modal-open');
    setShowDeleteConfirm(false);
  };

  const history = useHistory();

  const showChatInfo = () => {
    if (chatInfo) chatInfo();
  };

  const handleDeleteRoom = () => {
    setShowDeleteConfirm(true);
    document.body.classList.add('modal-open');
  };

  const confirmDeleteRoom = () => {
    const obj = {
        roomId: selected.pk,
    }
    deleteRoom(obj).then(async (e) => {
      dispatch(roomDeleteRequest({
        id: selected.pk,
      }));
      closeDeleteConfirm();
      setTimeout(() => {
        history.push('conversations-nearby');
        window.location.reload();
      }, 500);
    }).catch(() => {
      setToastValues({
        message: 'Something went wrong!',
        type: 'Error',
      });
      setToast(true);
      closeDeleteConfirm();
    });
  };

  const user = JSON.parse(localStorage.getItem('user') || '{}');



  const handleAccept = (id: string, user: any) => {
    const participants = selected?.participants?.length > 0 ? selected?.participants : [];
    const obj = {
      roomId: selected.pk,
      user: [...participants, user],
    }
    updateParticipantsInRoom(obj).then((e) => {
      // Remove the accepted request from Firebase
      const msgPath = `${selected.pk}/requests/${id}`;
      deleteRequest(msgPath).then(() => {
        // Show success toast after request is deleted
      setToastValues({
        message: 'Request approved!',
        type: 'Success',
      });
      setToast(true);
      
      // Set flag to check for modal closure when requests update
      setShouldCheckModalClose(true);
      }).catch((err) => {
        console.error('Failed to delete request from Firebase:', err);
        // Still show success toast - user was already added to room
        setToastValues({
          message: 'Request approved!',
          type: 'Success',
        });
        setToast(true);
        setShouldCheckModalClose(true);
      });
      
    }).catch(() => {
      setToastValues({
        message: 'Something went wrong!',
        type: 'Error',
      });
      setToast(true);
    });
  };

  const handleReject = (id: string) => {
    const msgPath = `${selected.pk}/requests/${id}`;
    deleteRequest(msgPath).then(() => {
      // Show success toast
      setToastValues({
        message: 'Request rejected!',
        type: 'Success',
      });
      setToast(true);
      
      // Set flag to check for modal closure when requests update
      setShouldCheckModalClose(true);
      
    }).catch(() => {
      setToastValues({
        message: 'Something went wrong!',
        type: 'Error',
      });
      setToast(true);
    });
    return '';
  };

  const joinRequests = () => (
    <div className="px-3">
      {requests.length === 0 ? (
        <div className="text-center">
          <p>No Request Found!</p>
        </div>
      ) : (
        requests.map((item: any, index: number) => (
            <div className={`mb-3 ${Styles.userDetails}`} key={index}>
              <img src={`${IMAGE_URL}${item.user.profile}`} alt="user" className={Styles.userImage} />
              <div className={Styles.detailsInner}>
                <div>
                  <h5 className="my-0">{item.user.name}</h5>
                  <span className="mb-0 fontFifteen font-weight-normal input-color">{item.user.email}</span><br/>
                  <span className="mb-0 fontFifteen font-weight-normal input-color">{item.time}</span>
                </div>
                <div>
                  <button type="button" onClick={() => handleAccept(item.id, item.user)} className="btn btn-sm btn-outline-primary">Accept</button>
                  <button type="button" onClick={() => handleReject(item.id)} className="btn btn-sm btn-outline-danger">Reject</button>
                </div>
              </div>
            </div>
        ))
      )}
      <div className="text-center">
        <Button label="Close" clickHandler={closeDialog} cssClass={Styles.closeButton} />
      </div>
    </div>
  );

  const deleteConfirmModal = () => (
    <div className="px-3">
      <div className="text-center mb-4">
        <p className="mb-3 font-weight-600">Are you sure you want to delete this room?</p>
      </div>
      <div className="d-flex justify-content-center column-gap-15">
        <Button 
          label="Cancel" 
          clickHandler={closeDeleteConfirm} 
          cssClass={Styles.closeButton} 
        />
        <Button 
          label="Delete" 
          clickHandler={confirmDeleteRoom} 
          cssClass={`${Styles.closeButton} ${Styles.deleteButton}`} 
        />
      </div>
    </div>
  );



  useEffect(() => {}, []);

  const activeListenerRef = useRef<(() => void) | null>(null);
  const currentRoomRef = useRef<number | null>(null);

  // Cleanup effect for component unmount
  useEffect(() => {
    return () => {
      if (activeListenerRef.current) {
        activeListenerRef.current();
        activeListenerRef.current = null;
        currentRoomRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (selected?.pk) {
      // Prevent multiple listeners for the same room
      if (currentRoomRef.current === selected.pk && activeListenerRef.current) {
        return;
      }

      // Cleanup previous listener if room changed
      if (activeListenerRef.current) {
        activeListenerRef.current();
        activeListenerRef.current = null;
      }

      const requestsRef = ref(db, `requests/${selected.pk}/requests`);
      currentRoomRef.current = selected.pk;
      
      // Set up the listener
      const unsubscribe = onValue(requestsRef, (querySnapshot: any) => {
        const requests: any = [];
        querySnapshot.forEach((doc: any) => {
          requests.push(doc.val());
        });
        if (requests.length > 0) {
          setRequests(requests);
        } else {
          setRequests([]);
        }
      });
      
      // Store the unsubscribe function
      activeListenerRef.current = unsubscribe;
      
      // Cleanup function
      return () => {
        if (activeListenerRef.current === unsubscribe) {
          activeListenerRef.current();
          activeListenerRef.current = null;
          currentRoomRef.current = null;
        }
      };
    } 
  }, [selected?.pk]); // Added selected?.pk dependency to re-run when room changes

  useEffect(() => {
    const interval = setInterval(() => {
      setToast(false);
    }, 6000);

    return () => {
      clearInterval(interval);
    }

  }, []);

  // Effect to handle modal closure when requests are processed
  useEffect(() => {
    if (shouldCheckModalClose && !requests.length) {
      closeDialog();
      setShouldCheckModalClose(false); // Reset the flag
    }
  }, [requests, shouldCheckModalClose]);

  // Effect to auto-open modal when selecting a room with pending requests
  useEffect(() => {
    if (selected?.pk && requests.length > 0 && selected?.host?.pk === user?.pk) {
      setJoinRequest(true);
    }
  }, [selected?.pk, requests.length]);

  const handleJoin = async () => {
    setIsVideoLoading(true);
    try {
      // If i am the owner of the room
      if (selected?.host?.pk === user?.pk) {
        if (selected?.participants?.length > 0) {
          const emails = [];
          for (const item of selected?.participants) {
            item && emails.push(item.email);
          }

        try {
          // Generate meeting link using utility function
          const meetingLink = generateMeetingLink(selected, window.location.origin);
          console.log('Generated meeting link:', meetingLink);

          // Use the dedicated meeting notification API instead of general notification
          api.sendMeetingNotificationEmail({
            emailTo: emails.join(','),
            notification: `The video has been started by the Host (${user.name}) for the room ${selected.topic}.

Join the call directly: ${meetingLink}

Room: ${selected.topic}
Host: ${user.name}
Start Time: ${new Date().toISOString()}

Click the link above to join the video call immediately.`,
            subject: `${selected.topic}'s video started by host - Join Now!`
          });

          console.log('Meeting notification email sent successfully');
        } catch (error) {
          console.error('Failed to send meeting notification email:', error);
        }
      }
      
      dispatch(roomStatusRequest({
        id: selected.pk,
        status: 'VIDEO',
      }));
    }
    
    if (selected?.host?.is_super_host) {
      if (isJoined) {
        history.push({ pathname: '/call', state: { selectedBroadCast: selected} });
      } else {
        // roomWithNoFees(true);
        // joinRoom(item);
      }
    } else {
      if (isJoined) {
        history.push({ pathname: '/call', state: { selectedBroadCast: selected} });
      } else {
        if (selected?.participants.length >= 3) {
          // roomWithFees(true);
          // joinRoom(item);
        } else {
          history.push({ pathname: '/call', state: { selectedBroadCast: selected} });
        }
      }
    }
    } catch (error) {
      console.error('Error in handleJoin:', error);
    } finally {
      setIsVideoLoading(false);
    }
  }
  return (
    <>
      <div className={`${cssClass} ${Styles.chatHeader}`}>
        <h4 className={`my-0 ${Styles.userName}`}>{name}</h4>
        <div className="d-flex align-items-center">
          {/* When the user is the host */}
          {(selected?.host?.pk === user?.pk) && (
            <Button
              label={selected.status !== 'VIDEO' ? "START VIDEO CHAT" : "JOIN VIDEO CHAT"}
              cssClass={Styles.createRoomWidth}
              src={socialPlayFavIcon}
              alt="chat info"
              imageClass={Styles.chatHeaderImg}
              clickHandler={handleJoin}
              image
              showLoading={isVideoLoading}
              disabled={isVideoLoading}
            />)}

          {/* When the user is not the host and the video is started */}
          {(selected?.host?.pk !== user?.pk && (isJoined && selected.status === 'VIDEO')) && (
            <Button
              label="JOIN VIDEO CHAT"
              cssClass={Styles.createRoomWidth}
              src={socialPlayFavIcon}
              alt="chat info"
              imageClass={Styles.chatHeaderImg}
              clickHandler={handleJoin}
              image
              showLoading={isVideoLoading}
              disabled={isVideoLoading}
            />)}

          {isJoined && (
            <div
              onClick={showChatInfo}
              onKeyPress={showChatInfo}
              role="button"
              tabIndex={0}
            >
              <img
                src={chatInfoImage}
                alt="chat info"
                className={Styles.chatInfoImage}
              />
            </div>
          )}
          {selected?.host?.pk === user?.pk && (
            <>
              <div
                onClick={handleDeleteRoom}
                onKeyPress={handleDeleteRoom}
                role="button"
                tabIndex={0}
              >
                <img
                  src={deleteIcon}
                  alt="delete icon"
                  className={Styles.deleteImage}
                />
              </div>
              <div
                className="position-relative"
                onClick={() => setJoinRequest(true)}
                onKeyPress={() => setJoinRequest(true)}
                role="button"
                tabIndex={0}
              >
                <img
                  src={userRequestIcon}
                  alt="delete icon"
                  className={Styles.requestImage}
                />
                {requests.length > 0 && (
                  <div className={Styles.userRequestCounter}>
                    {requests.length}
                  </div>
                )}
              </div>
            </>
          )}

        </div>


        {joinRequest && (
        <CustomModal
          title="Join Requests"
          wrapperClass={Styles.publicProfileWrapper}
          heightClass={Styles.publicProfileBody}
          closeDialog={closeDialog}
        >
          {joinRequests()}
        </CustomModal>
      )}

        {showDeleteConfirm && (
          <CustomModal
            title="Delete Room"
            wrapperClass={Styles.publicProfileWrapper}
            heightClass={Styles.publicProfileBody}
            closeDialog={closeDeleteConfirm}
          >
            {deleteConfirmModal()}
          </CustomModal>
        )}

        {toast && (
          <Toast
            message={toastValues.message}
            position="topRight"
            type={toastValues.type}
            handleCloseToast={setToast}
          />
        )}
      </div>
    </>
  );
};

const mapDispatchToProps = { invitePeople: invitePeopleRequest };

export default connect(null, mapDispatchToProps)(ChatHeader);